import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import cn from 'classnames';
import SortDropDown from './SortDropDown';
import ListOption from './ListOption';

const FolderContents = props => {
  const {
    handleListDropDownClick,
    sortOptions,
    onChangeList,
    activeFolderId,
    lists,
    showSubMenu,
    handleShowSubMenu,
    current,
    handleModal,
    subMenuTop,
  } = props;
  const filteredLists = lists.filter(list => list.list_group_id === activeFolderId);
  const listInFoldersClassName = 'sort-lists-in-folders-drop-down';

  const [openSortListsInFolderDropdown, setOpenSortListsInFolderDropdown] = useState(false);

  const [activeSortListsInFolderSortOption, setActiveSortListsInFolderSortOption] = useState(
    localStorage.getItem('activeSortListsInFolderSortOption') || 'Date last modified'
  );

  const [selectedSortListsInFolderOption, setSelectedSortListsInFolderOption] = useState(
    activeSortListsInFolderSortOption
  );

  const handleSortListsInFolders = opt => {
    setActiveSortListsInFolderSortOption(opt);
    localStorage.setItem('activeSortListsInFolderSortOption', opt);
    sortListsInFolderByOption(opt);
  };

  const sortListsInFolderByOption = option => {
    switch (option) {
      case 'Title A - Z':
        return [...filteredLists].sort((a, b) => a.title.localeCompare(b.title));
      case 'Title Z - A':
        return [...filteredLists].sort((a, b) => b.title.localeCompare(a.title));
      case 'Newest to oldest':
        return [...filteredLists].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      case 'Oldest to newest':
        return [...filteredLists].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      case 'Date last modified':
        return [...filteredLists].sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
      default:
        return filteredLists;
    }
  };

  const listsToRenderinFolderSubMenu = sortListsInFolderByOption(
    activeSortListsInFolderSortOption
  ).map(list => {
    return (
      <div key={list.id} onClick={() => handleShowSubMenu(false)}>
        <ListOption
          handleModal={handleModal}
          current={current}
          subMenu
          list={list}
          onChangeList={onChangeList}
          handleListDropDownClick={handleListDropDownClick}
        />
      </div>
    );
  });

  return (
    <div
      className={cn('list-sub-menu do-not-close-dropdown', {
        open: showSubMenu,
        'overflow-auto': filteredLists.length > 5,
      })}
      style={{ top: `${subMenuTop}px` }}
      id={`active-folder-${activeFolderId}`}
    >
      {filteredLists.length > 1 ? (
        <div className="sort-lists-in-folder">
          <span
            onClick={() => setOpenSortListsInFolderDropdown(current => !current)}
            className="sort-lists-in-folder-dropdown"
            tabIndex={0}
            role="button"
          >
            Sort: {activeSortListsInFolderSortOption}
            <FontAwesome
              className={`sort-arrow ${openSortListsInFolderDropdown ? 'sort-arrow-open' : ''}`}
              name="caret-up"
              size="lg"
            />
          </span>
          {openSortListsInFolderDropdown && (
            <SortDropDown
              className={listInFoldersClassName}
              setSelectedOption={setSelectedSortListsInFolderOption}
              selectedOption={selectedSortListsInFolderOption}
              sortDropdownOpen={openSortListsInFolderDropdown}
              handleSort={handleSortListsInFolders}
              setOpenSortDropdown={setOpenSortListsInFolderDropdown}
              sortOptions={sortOptions}
            />
          )}
        </div>
      ) : null}
      {filteredLists.length > 0 ? (
        listsToRenderinFolderSubMenu
      ) : (
        <div className="empty-list-sub-menu" id={`active-folder-${activeFolderId}`}>
          <span>You currently do not have any lists in this folder.</span>
        </div>
      )}
    </div>
  );
};

FolderContents.propTypes = {
  handleListDropDownClick: propTypes.func,
  sortOptions: propTypes.array,
  onChangeList: propTypes.func,
  activeFolderId: propTypes.oneOfType([propTypes.number, propTypes.string]),
  lists: propTypes.array,
  showSubMenu: propTypes.bool,
  handleShowSubMenu: propTypes.func,
  current: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  handleModal: propTypes.func,
  subMenuTop: propTypes.number,
};

export default FolderContents;
